// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-shadow[data-v-26700dd0]{border:2px solid rgba(254,235,172,.35)}.make-amber[data-v-26700dd0]{color:gold}.save-button[data-v-26700dd0]{background-color:#4abca5;color:#fff}.flex-d[data-v-26700dd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
